import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Common } from '../../shared/common';
import { Voter } from 'src/app/models/Voter';

@Component({
  selector: 'buy-options-popup',
  templateUrl: './buy-options-popup.component.html',
  styleUrls: ['./buy-options-popup.component.less', '../../shared/common.less']
})
export class BuyOptionsPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() sendDownloadOrder = new EventEmitter<boolean>();
  @Output() hotlineOptionEmitter = new EventEmitter<boolean>();
  @Output() SMSOptionEmitter = new EventEmitter<number>();

  @Input() isAssoc: boolean;
  @Input() licenseTime: string;
  @Input() voters: Array<Voter>;
  @Input() SMSOwned: number = 0;
  @Input() SMSOffers: boolean;

  @Input() mails = [];
  @Input() isAssessors = false;
  @Input() assessors = []
  messageLength = 0

  constructor(public common: Common) { }

  SMSOption(option: any) {
    this.SMSOptionEmitter.emit(option)
  }

  hotlineOption(option: any) {
    this.hotlineOptionEmitter.emit(option)
  }

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  downloadVoterFile() {
    this.sendDownloadOrder.emit(true);
  }

}
